import mulixVisa from './mulix-visa'
import mulixPayretailers from './mulix-payretailers'

export default {
  mulixVisa,
  mulixPayretailers,
}



// WEBPACK FOOTER //
// ./src/views/finance/withdraw-methods/mulix-wd-methods/index.js